const LABEL_FORWARDED_VALUE_LIVE = 'live';
const LABEL_FORWARDED_VALUE_NOT_LIVE = 'not-live';

export function getForwardedHost(): string {
    if (typeof window === 'undefined') {
        return LABEL_FORWARDED_VALUE_NOT_LIVE;
    }

    const hostname = window.location.hostname;
    if (!hostname) {
        return LABEL_FORWARDED_VALUE_NOT_LIVE;
    }

    return ['www.1stdibs.com', 'adminv2.1stdibs.com'].includes(hostname)
        ? LABEL_FORWARDED_VALUE_LIVE
        : LABEL_FORWARDED_VALUE_NOT_LIVE;
}
